import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';
import { CATEGORIES } from '../../../config/const';
import { normalize } from '../../../helpers/pagination';

const state = {
  categories: {
    isBusy: false,
    data: null,
    error: null
  },

  category: {
    isBusy: false,
    data: null,
    error: null
  },
};

const mutations = {
  LOAD_CATEGORIES_BUSY: (state, payload) => {
    state.categories.isBusy = payload;
  },
  LOAD_CATEGORIES_SUCCESS: (state, payload) => {
    state.categories.data = payload.data;
    state.categories.error = null;
  },
  LOAD_CATEGORIES_FAIL: (state, payload) => {
    state.categories.data = null;
    state.categories.error = payload;
  },

  CREATE_CATEGORY_BUSY: (state, payload) => {
    state.category.isBusy = payload;
  },
  CREATE_CATEGORY_SUCCESS: (state, payload) => {
    state.category.data = payload;
    state.category.error = null;
  },
  CREATE_CATEGORY_FAIL: (state, payload) => {
    state.category.data = null;
    state.category.error = payload;
  },

  UPDATE_CATEGORY_BUSY: (state, payload) => {
    state.category.isBusy = payload;
  },
  UPDATE_CATEGORY_SUCCESS: (state, payload) => {
    let category = state.categories.data.data.find(category => {
      return category.id === payload.id;
    });

    Object.keys(category).forEach(key => {
      category[key] = payload[key];
    })

    state.category.data = payload;
    state.category.error = null;
  },
  UPDATE_CATEGORY_FAIL: (state, payload) => {
    state.category.data = null;
    state.category.error = payload;
  },

  DELETE_CATEGORY_BUSY: (state, payload) => {
    state.category.isBusy = payload;
  },
  DELETE_CATEGORY_SUCCESS: (state, payload) => {
    state.category.data = payload;
    state.category.error = null;
  },
  DELETE_CATEGORY_FAIL: (state, payload) => {
    state.category.data = null;
    state.category.error = payload;
  }
};

const actions = {
  getCategories: ({ commit, rootState, state }, { projectId, pagination }) => {

    commit('LOAD_CATEGORIES_BUSY', true);

    let query = "?";
    const normalizedPagination = normalize(pagination);

    Object.keys(normalizedPagination).map((param, i) => {
      query += `${param}=${normalizedPagination[param]}${i !== Object.keys(normalizedPagination).length - 1 ? '&' : ''}`;
    });

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios.get(`${API_HOST}/analysis/${projectId}/categories${query}`, config)
      .then(response => {

        let data = response.data;
        if (pagination.page > 1) {
          const categories = state.categories.data.data;
          data = {
            data: {
              ...data.data,
              data: [
                ...categories,
                ...data.data.data
              ]
            }
          }
        }
        commit("LOAD_CATEGORIES_SUCCESS", data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_CATEGORIES_FAIL", error);
      })
      .finally(() => {
        commit("LOAD_CATEGORIES_BUSY", false);
      });
  },

  createCategory: ({ commit, rootState }, { projectId, category }) => {
    commit("CREATE_CATEGORY_BUSY", true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios.post(`${API_HOST}/analysis/${projectId}/categories/create`, category, config)
      .then(response => {
        if (!response.data.error) {
          commit("CREATE_CATEGORY_SUCCESS", response.data);
        }
        return response.data;
      })
      .catch(error => {
        const text = error.response.data.message === "duplicated" ? "messages.request.duplicated" : "messages.request.error";
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t(text)
        });

        console.error(error);
        commit("CREATE_CATEGORY_FAIL", error);
      })
      .finally(() => commit("CREATE_CATEGORY_BUSY", false));
  },

  updateCategory: ({ commit, rootState }, { projectId, category }) => {
    commit("UPDATE_CATEGORY_BUSY", true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    const body = { ...category };

    return Axios.put(
      `${API_HOST}/analysis/${projectId}/categories/${category.id}/update`,
      body,
      config
    )
      .then(response => {
        if (!response.data.error) {
          commit("UPDATE_CATEGORY_SUCCESS", response.data);
          return response.data;
        }
        else {
          Vue.notify({
            group: "store_notifications",
            type: "error",
            text: i18n.t(`category.form.errors.${response.data.error}`)
          });
        }
      })
      .catch(error => {
        if (!error.response || !error.response.data || error.response.data.message !== CATEGORIES.ERRORS.TAGS_IN_USE) {
          Vue.notify({
            group: "store_notifications",
            type: "error",
            text: i18n.t("messages.request.error")
          });
        }
        console.error(error);
        commit("UPDATE_CATEGORY_FAIL", error);
        return error;
      })
      .finally(() => commit("UPDATE_CATEGORY_BUSY", false));
  },

  deleteCategory: ({ commit, rootState }, { projectId, categoryId }) => {
    commit("DELETE_CATEGORY_BUSY", true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios.delete(
      `${API_HOST}/analysis/${projectId}/categories/${categoryId}/delete`,
      config
    )
      .then((response) => {
        commit("DELETE_CATEGORY_SUCCESS", response.data.id);
        return response.data.id;
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("DELETE_CATEGORY_FAIL", error);
      })
      .finally(() => commit("DELETE_CATEGORY_BUSY", false));
  },
  deleteBulkCategory: ({ commit, rootState }, { projectId, bulkTags}) => {
    commit("DELETE_CATEGORY_BUSY", true);
    const data = [
      ...bulkTags,
    ];
    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` },
      data
    };

    return Axios.delete(
      `${API_HOST}/analysis/${projectId}/categories/bulk/delete`,
      config
    )
      .then((response) => {
        //commit("DELETE_CATEGORY_SUCCESS", response.data.id);
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("DELETE_CATEGORY_FAIL", error);
      })
      .finally(() => commit("DELETE_CATEGORY_BUSY", false));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};